import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  max-width: 958px;
  margin: 0 auto;
  padding: 32px 0;
`
